const IconSortUpActive = (props) => {
    return (
        <svg className={props.className} width="27" height="15" viewBox="0 0 27 15" stroke="#FFFFFF" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25.315 13.2L13.201 1.086L1.086 13.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default IconSortUpActive;